export const REVERSAL_MIN_REASON_LENGTH: number = 10;

export const REVERSAL_LABELS = {
  TITLE: "Reverter lançamento",
  MENU: "Reverter",
  DESCRIPTION: "Confira o efeito contábil antes de confirmar",
  SUCCESS: "Reversão registrada.",
  ERROR: "Não foi possível reverter este caso.",
  ALREADY_REVERTED: "Já revertido",
  BATCH_MENU: "Reverter",
  BATCH_SUCCESS: (count: number): string =>
    count === 1
      ? "1 caso revertido."
      : `${count} casos revertidos.`,
  BATCH_PARTIAL: (count: number, skippedSummary: string): string =>
    `${count} ${count === 1 ? "caso revertido" : "casos revertidos"}. Ficaram de fora: ${skippedSummary}.`,
  CREDITED_TO_EMPLOYEE: "Crédito ao colaborador",
  CANCELLED_INSTALLMENTS: "Parcelas canceladas",
  LOSS_ON_STORE: "Perda na loja",
  LOSS_WARNING:
    "A Perda na loja é o valor cheio da divergência, não o que foi creditado — a falta de caixa continua existindo; o colaborador é que deixou de pagá-la.",
  REASON: "Motivo da reversão",
  REASON_REMAINING: (missing: number): string =>
    `Faltam ${missing} caractere(s) para o mínimo exigido.`,
  CONFIRM: "Confirmar reversão",
  CANCEL: "Cancelar",
  BATCH_TITLE: "Reverter em lote",
  BATCH_TOTAL: (amount: string): string =>
    `Total a cancelar nos itens elegíveis: ${amount}`,
  BATCH_REMOVED: (count: number): string =>
    `${count} item(ns) saíram do lote por já ter parcela COBRADA — esses exigem reversão individual.`,
  PERIOD_CLOSED_TOOLTIP: "Período fechado — apenas reversão é permitida",
  REVERTED_BADGE: "Revertido",
  NO_OPEN_CYCLE:
    "O ciclo fiscal aberto não veio da API — sem ele não dá para dizer o que será creditado.",
} as const;

export const REVERSAL_TOASTS = {
  NO_OPEN_CYCLE: {
    description: REVERSAL_LABELS.NO_OPEN_CYCLE,
    variant: "destructive",
    duration: 5000,
  },
} as const;

export const REVERSAL_SKIP_REASON_LABELS: Readonly<Record<string, string>> = {
  NOT_FOUND: "não encontrado",
  NOT_DECIDED: "ainda não decidido",
  NOT_REVERSIBLE: "não é um caso aprovado",
  ALREADY_REVERSED: "já revertido",
  ALREADY_CHARGED: "com parcela já cobrada (exige reversão individual)",
  VERSION_CONFLICT: "alterado por outra pessoa durante o lote",
  FAILED: "falhou ao reverter",
} as const;
